import { connect } from "react-redux";
import RatingsSpread from "./RatingsSpread";


const mapStateToProps = (state) => ({
    fetchDistributionStripApi: state.BenchmarkFilteringReducer.fetchDistributionStripApi,
    scaleType: state.BenchmarkFilteringReducer.scaleType,


});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(RatingsSpread);
